import React from 'react';
import styled from 'styled-components';
import { style } from '../../api';

const Bar = styled.div`
  position: relative;
  height: 6px;
  background-color: ${style.grey_light_1_new};
  width: 100%;
`;

const Progress = styled.div`
  height: 100%;
  background-color: red;
`;

const getColor = (progress: number) => {
  if (progress <= 50) return style.warning_new;
  return style.success_new;
};

const ProgressBar = ({ total, left }: { total: number; left: number }) => {
  const progress = ((total - left) / total) * 100;
  return (
    <Bar>
      <Progress
        style={{
          width: `${progress}%`,
          background: getColor(progress),
        }}
      />
    </Bar>
  );
};

export default ProgressBar;
